module.exports = __webpack_public_path__ + "assets/icon-details.9dc317a4.svg";